import { Entidade, Osc, Usuario } from "../model";

export class UsuarioHasEntidade {
    id:number;
    usuario = new Usuario();
    entidadeConcedente = new Entidade();
    entidadeProponente = new Osc();
    principal:boolean;
    excluido:boolean;
}